/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Button_LabelInputs */

const en_settings_button_label = /** @type {(inputs: Settings_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

const fr_settings_button_label = /** @type {(inputs: Settings_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres`)
};

const ms_sg2_settings_button_label = /** @type {(inputs: Settings_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetapan`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Settings_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const settings_button_label = /** @type {((inputs?: Settings_Button_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Button_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_button_label(inputs)
	if (locale === "fr") return fr_settings_button_label(inputs)
	return ms_sg2_settings_button_label(inputs)
});